export interface Icon {
  name: String;
  group: IconGroup;
}
export enum IconGroup {
  normal,
  brand,
}
